import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';

// Lazy load pages for better performance
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Sessions = lazy(() => import('../pages/Sessions'));
const Students = lazy(() => import('../pages/Students'));
const Settings = lazy(() => import('../pages/Settings'));

// Loading component
const Loading = () => (
  <View as="div" textAlign="center">
    <Spinner renderTitle="Loading" size="large" />
  </View>
);

const ProctorRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/students" element={<Students />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/proctor" replace />} />
      </Routes>
    </Suspense>
  );
};

export default ProctorRoutes;
